import { useSelector } from 'react-redux';
import { selectIsSuburban } from '../../../../selectors/filters';

export function useTitle() {
  const isSuburban = useSelector(selectIsSuburban);

  if (isSuburban) {
    return {
      mainText: 'История объявлений рядом',
    };
  }

  return {
    mainText: 'История объявлений',
    secondaryText: 'В этом и соседних домах',
  };
}
